import {
  BitfStrapiFormItemsConfigApiRequestPart,
  BitfStrapiPaginationApiRequestPart,
  BitfStrapiSearchApiRequestPart,
  BitfStrapiSortApiRequestPart,
} from '@common/libs/bitforce/core/api-call-state/bitf-strapi-api-call-state';
import { EBitfStrapiQueryComparator } from '@common/libs/bitforce/core/parsers/strapi-parser';
import { EApiCallStateNames, EApiRequestPartKeys, EBitfApiSortDirection, EBookletStatus } from '@enums';
import { IBitfApiCallState } from '@interfaces';
import {
  DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING,
  DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING_END,
} from '@web/constants/constants';
import { DefaultApiCallStateMapper } from './default-api-call-state.mapper';

export const apiCallStateConfig = [
  {
    apiCallStateName: EApiCallStateNames.BOOKLETS,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 10 },
        options: { pageIndexOffset: 1 },
      }),

      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING,
        defaultPartData: { data: { property: 'createdAt', direction: EBitfApiSortDirection.DESC } },
      }),
      new BitfStrapiSearchApiRequestPart(),
      new BitfStrapiFormItemsConfigApiRequestPart(),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,

  {
    apiCallStateName: EApiCallStateNames.ADMIN_BOOKLETS_LIST,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 20 },
        options: { pageIndexOffset: 1 },
      }),

      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_AGENCY,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_STATUS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_CREATED_AT,
        defaultPartData: { data: { property: 'createdAt', direction: EBitfApiSortDirection.DESC } },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_PROPERTY_ADDRESS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_SELLER_SURNAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_AGENT_SURNAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_TECHNICAL_REPORT_SURVEYOR,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_APE_SURVEYOR,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_BOOKLETS_LIST_EXTRA_SURVEYOR,
      }),
      new BitfStrapiSearchApiRequestPart(),
      new BitfStrapiFormItemsConfigApiRequestPart(),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.ADMIN_ACCOUNTING_BOOKLETS_LIST,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 20 },
        options: { pageIndexOffset: 1 },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_CREATED_AT,
        defaultPartData: { data: { property: 'createdAt', direction: EBitfApiSortDirection.DESC } },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_AGENCY,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_PROPERTY_DEED_OF_SALE,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_PROPERTY_ADDRESS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_SELLER_SURNAME,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_TECHNICAL_REPORT_SURVEYOR,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_APE_SURVEYOR,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_ACCOUNTING_EXTRA_SURVEYOR,
      }),
      new BitfStrapiSearchApiRequestPart(),
      new BitfStrapiFormItemsConfigApiRequestPart({
        defaultPartData: {
          formValue: {
            createdAt: [DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING, DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING_END],

            bookletStatus: [
              EBookletStatus.NEW,
              EBookletStatus.DUE_DILIGENCE,
              EBookletStatus.DOC_READY,
              EBookletStatus.ARCHIVED,
            ],
          },
          data: {
            formItemsConfig: {
              createdAt: {
                comparator: EBitfStrapiQueryComparator.BETWEEN,
              },
              bookletStatus: {
                comparator: EBitfStrapiQueryComparator.IN,
              },
            },
          },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
  {
    apiCallStateName: EApiCallStateNames.ADMIN_PARTNERS_LIST,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 20 },
        options: { pageIndexOffset: 1 },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_PARTNERS_LIST_AGENCY,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_PARTNERS_LIST_CREATED_AT,
        defaultPartData: { data: { property: 'createdAt', direction: EBitfApiSortDirection.DESC } },
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_PARTNERS_LIST_PROPERTY_ADDRESS,
      }),
      new BitfStrapiSortApiRequestPart({
        key: EApiRequestPartKeys.SORTING_ADMIN_PARTNERS_LIST_SELLER_SURNAME,
      }),

      new BitfStrapiSearchApiRequestPart(),
      new BitfStrapiFormItemsConfigApiRequestPart(),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,

  {
    apiCallStateName: EApiCallStateNames.ADMIN_DASHBOARD,
    requestParts: [
      new BitfStrapiPaginationApiRequestPart({
        key: EApiRequestPartKeys.PAGINATION,
        initialPagination: { page: 1, size: 100 },
        options: { pageIndexOffset: 1 },
      }),
      new BitfStrapiSearchApiRequestPart(),
      new BitfStrapiFormItemsConfigApiRequestPart({
        defaultPartData: {
          formValue: {
            createdAt: [DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING, DEFAULT_DATE_FILTER_ADMIN_ACCOUNTING_END],
            bookletStatus: [
              EBookletStatus.NEW,
              EBookletStatus.DUE_DILIGENCE,
              EBookletStatus.DOC_READY,
              EBookletStatus.ARCHIVED,
            ],
          },
          data: {
            formItemsConfig: {
              createdAt: {
                comparator: EBitfStrapiQueryComparator.BETWEEN,
              },
            },
          },
        },
      }),
    ],
    apiCallStateMapper: new DefaultApiCallStateMapper(),
  } as IBitfApiCallState,
];
